import React from 'react'
import { graphql } from 'gatsby'
import { useJsonForm } from 'gatsby-tinacms-json'
import { usePlugin } from 'tinacms'
import { InlineForm, InlineTextarea } from 'react-tinacms-inline'
import { InlineWysiwyg } from 'react-tinacms-editor'

import Layout from '../components/Layout'
import Image from '../components/Image'
import SEO from '../components/Seo'

const IndexPage = ({ data }) => {
    const formConfig = {
        id: 1212,
        label: 'Edit Home Page',
        fields: [
            {
                label: 'SEO Title',
                name: 'rawJson.seo_title',
                component: 'textarea'
            },
            {
                label: 'Meta Description',
                name: 'rawJson.meta_description',
                component: 'textarea'
            }
        ]
    }


    const [modifiedData, form] = useJsonForm(data.page, formConfig)
    usePlugin(form)

    return (
        <>
            <SEO
                title={modifiedData.seoTitle}
                description={modifiedData.metaDescription}
            />
            <Layout>
                <div className="mainContainer">
                    <InlineForm form={form} >
                        <div className="hero">
                            <div className="container">
                                <div className="jumbotron">
                                    <h1><InlineTextarea name="rawJson.title" /></h1>
                                </div>
                            </div>
                        </div>
                        <section id="bbb-credit">
                            <div className="container">
                                <div className="col-md-9 bbb"><InlineTextarea name="rawJson.text1" /></div>
                                <div className="col-md-3 bbb">
                                    <a href="https://www.bbb.org/us/ca/san-diego/profile/internet-service/instant-checkmate-inc-1126-172003447">
                                        <Image imgsrc="bbb.png" alt="Better Business Bureau Logo" width="100" />
                                    </a>
                                </div>
                            </div>
                        </section>
                        <div id="howTo" className="container s1 anchor">
                            <div className="row">
                                <div className="col-md-8"><Image className="mock" imgsrc="How-Use-Instant-Checkmate.png" alt="How to use Instant Checkmate" />
                                    <InlineWysiwyg name="rawJson.text2" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.text2,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                </div>
                                <div className="col-md-4">
                                    <h4>How-To Videos</h4>
                                    <a className="btn btn-lg btn-default" href="/create-account/">Create an account</a> <a className="btn btn-lg btn-default" href="/login-account/">Login to your account</a> <a className="btn btn-lg btn-default" href="/cancel-account/">Cancel your account</a> <a className="btn btn-lg btn-default" href="/change-password/">Change your password</a> <a className="btn btn-lg btn-default" href="/remove-information/">Remove your information</a> <a className="btn btn-lg btn-default" href="/background-search/">Background search anyone</a></div>
                            </div>
                        </div>
                        <div className="container-fluid s2">
                            <div className="container">
                                <div className="row">
                                    <h2>Frequently Asked Questions</h2>
                                    <hr /></div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <InlineWysiwyg name="rawJson.faqsText1" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.faqsText1,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                    <div className="col-md-6">
                                        <InlineWysiwyg name="rawJson.faqsText2" format="html">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: modifiedData.faqsText2,
                                                }}
                                            />
                                        </InlineWysiwyg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid s3">
                            <div className="container">
                                <div className="row">
                                    <InlineWysiwyg name="rawJson.testimonialsTitle" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.testimonialsTitle,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                    <hr />
                                </div>
                                <div className="row testimonial">
                                    {modifiedData.testimonials.map((t, index) => {
                                        return (
                                            <div key={index} className="col-md-4">
                                                <p>
                                                    <InlineTextarea name={`rawJson.testimonials.${index}.text`} />
                                                </p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid s4">
                            <div className="container">
                                <div className="row">
                                    <InlineWysiwyg name="rawJson.heardText1" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.heardText1,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                    <hr />
                                </div>
                                <div className="row">
                                    <InlineWysiwyg name="rawJson.heardText2" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.heardText2,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                </div>
                                <div className="row featured">
                                    <div className="col-md-6"><Image imgsrc="discoveryLogo.png" style={{ width: "234px" }} alt="Discovery Logo" /> <iframe title="unique" style={{ width: '100%' }} src="https://www.youtube.com/embed/JY3pMYdx8Lg?rel=0&amp;showinfo=0" allowFullScreen=""></iframe></div>
                                    <div className="col-md-6"><Image imgsrc="nbcLogo.png" style={{ width: "113px" }} alt="NBC Logo" /> <iframe title="unique2" style={{ width: '100%' }} src="https://www.youtube.com/embed/8TXNjwtXYRc?rel=0&amp;showinfo=0" allowFullScreen=""></iframe></div>
                                </div>
                                <div className="row seenOn hideMobile">
                                    <div className="col-sm-1"><Image imgsrc="forbesLogo.png" alt="Forbes Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="huffLogo.png" alt="Huff Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="salesforceLogo.png" alt="Salesforce Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="amazonLogo.png" alt="AMazon Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="dailymailLogo.png" alt="Daily Mail Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="lifehackerLogo.png" alt="Lifehacker Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="mashableLogo.png" alt="Mashable Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="uproxxLogo.png" alt="Uproxx Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="wiredLogo.png" alt="Wired Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="cnetLogo.png" alt="CNET Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="bustleLogo.png" alt="Bustle Logo" /></div>
                                    <div className="col-sm-1"><Image imgsrc="hubspotLogo.png" alt="Hubspot Logo" /></div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid s5">
                            <div className="container">
                                <div className="row">
                                    <InlineWysiwyg name="rawJson.about" format="html">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: modifiedData.about,
                                            }}
                                        />
                                    </InlineWysiwyg>
                                </div>
                            </div>
                        </div>
                    </InlineForm>
                </div>
            </Layout>
        </>
    )
}

export default IndexPage

export const pageQuery = graphql`
query {
    page: pagesJson(path: {eq: "/index"}) {
        title
        text1
        text2
        faqsText1
        faqsText2
        testimonialsTitle
        testimonials {
            text
        }
        heardText1
        heardText2
        about
        metaDescription: meta_description
        seoTitle: seo_title

        rawJson
        fileRelativePath
    }
}`